export default __webpack_public_path__ + "static/media/T124MANA2.3d08810e.pdf";